// @TODO Rename StreamType - remove stream from it and add a new prefix
export var UTVPlayerStreamType;
(function (UTVPlayerStreamType) {
    UTVPlayerStreamType["LIVE"] = "LIVE";
    UTVPlayerStreamType["REPLAY"] = "REPLAY";
    UTVPlayerStreamType["RECORDING"] = "RECORDING";
    UTVPlayerStreamType["TIMESHIFT"] = "TIMESHIFT";
    UTVPlayerStreamType["VOD_MOVIE"] = "VOD_MOVIE";
    UTVPlayerStreamType["VOD_EPISODE"] = "VOD_EPISODE";
    UTVPlayerStreamType["VOD_TRAILER"] = "VOD_TRAILER";
})(UTVPlayerStreamType || (UTVPlayerStreamType = {}));
export var UTVPlayerErrorType;
(function (UTVPlayerErrorType) {
    UTVPlayerErrorType["PIN_ERROR"] = "PIN_ERROR";
    UTVPlayerErrorType["STREAM_CANNOT_PLAY"] = "STREAM_CANNOT_PLAY";
    UTVPlayerErrorType["FORBIDDEN_ACTION"] = "FORBIDDEN_ACTION";
    UTVPlayerErrorType["UNKNOWN"] = "UNKNOWN";
})(UTVPlayerErrorType || (UTVPlayerErrorType = {}));
export var QualityRestrictedType;
(function (QualityRestrictedType) {
    QualityRestrictedType["DRM_LIMITED"] = "DRM_LIMITED";
    QualityRestrictedType["QUALITY_LIMITED"] = "QUALITY_LIMITED";
})(QualityRestrictedType || (QualityRestrictedType = {}));
export var UTVPlayerEvents;
(function (UTVPlayerEvents) {
    UTVPlayerEvents["PAUSED"] = "PAUSED";
    UTVPlayerEvents["STOPPED"] = "STOPPED";
    UTVPlayerEvents["PLAYING"] = "PLAYING";
    UTVPlayerEvents["PLAY_REQUESTED"] = "PLAY_REQUESTED";
    UTVPlayerEvents["CLOSE_TO_END"] = "CLOSE_TO_END";
    UTVPlayerEvents["ERROR"] = "ERROR";
    UTVPlayerEvents["INITIALIZED"] = "INITIALIZED";
    UTVPlayerEvents["STATE_UPDATED"] = "STATE_UPDATED";
    UTVPlayerEvents["TRACK_UPDATED"] = "TRACK_UPDATED";
    /**
     * Sync content progress position to UTV meta data (to update teaser progress, etc).
     * Progress bar position is updated separately using the currentMs.
     *
     * Dispatching this event does not necessarily mean the position is updated on the backend.
     */
    UTVPlayerEvents["POSITION_SYNC"] = "POSITION_SYNC";
    UTVPlayerEvents["QUALITY_RESTRICTED"] = "QUALITY_RESTRICTED";
    // Propagated as its own event as this is needed to be tracked on UTV
    UTVPlayerEvents["AD_BREAK_SKIP_AVAILABLE"] = "AD_BREAK_SKIP_AVAILABLE";
    /**
     * when the stream is finally ready, this is when the timings are ready to be consumed
     * also happens when live switches to timeshift or replay
     */
    UTVPlayerEvents["STREAM_READY"] = "STREAM_READY";
    /**
     * Added for Cast events
     */
    UTVPlayerEvents["CAST_MEDIA_TRACKS_CHANGED"] = "CAST_MEDIA_TRACKS_CHANGED";
    UTVPlayerEvents["CAST_MEDIA_TRACK_SELECTION_CHANGED"] = "CAST_MEDIA_TRACK_SELECTION_CHANGED";
    UTVPlayerEvents["AD_BREAK_STARTED"] = "AD_BREAK_STARTED";
    UTVPlayerEvents["AD_BREAK_ENDED"] = "AD_BREAK_ENDED";
    UTVPlayerEvents["AD_CUE_POINTS_AVAILABLE"] = "AD_CUE_POINTS_AVAILABLE";
    // @TODO Placeholder for undefined events
    UTVPlayerEvents["UNKNOWN"] = "UNKNOWN";
})(UTVPlayerEvents || (UTVPlayerEvents = {}));
